import { Component, OnInit } from '@angular/core';
import { filter, Observable, Subject, takeUntil } from 'rxjs';
import { DataService } from '../../../services/data/data.service';
import { Ga4Service } from '../../../services/ga4/ga4.service';
import { LOGO_HEADER, MYACCOUNT_LOGGEDIN_PM, MYACCOUNT_LOGGEDIN_SR, MYACCOUNT_VIVR_PM, MYACCOUNT_VIVR_SR, SR_PM_INIT_FLOW_HEADER } from '../../../services/ga4/ga4.constant';
import {  Router } from '@angular/router';
import { APP_ROUTES } from '../../../utils/route.constant';

@Component({
  selector: 'app-tunnel-header',
  templateUrl: './tunnel-header.component.html',
  styleUrl: './tunnel-header.component.scss'
})
export class TunnelHeaderComponent implements OnInit {

  user$: Observable<any> | undefined;
  logoClass$: Observable<string | null> | undefined;
  visible: boolean = false;
  cleaner$ = new Subject<void>();
  title:string='';
  showDialog: boolean = false;
  showFfsBanner:boolean = false;

  constructor(
    private dataService: DataService,
    private gaService: Ga4Service,
    private router: Router
  ) { }


  ngOnInit(): void {
    this.logoClass$ = this.dataService.LogoClass$;
    this.dataService.tunnelHeaderHeading$.pipe(takeUntil(this.cleaner$)).subscribe(title => this.title = title);
    this.showFfsBanner = this.computeShowFfsBanner(this.router.url);

    // Also react to contract changes that affect isPlanFFS
    this.dataService.contractData$
      .pipe(takeUntil(this.cleaner$))
      .subscribe(() => {
        this.showFfsBanner = this.computeShowFfsBanner(this.router.url);
      });
  }

  onLogoClick(){
    const isVivr = this.dataService.isVivr$.getValue();
    const isPreventativeMaintenance = this.dataService.isPreventativeMaintenance$.getValue();
    
    const funnelName = isVivr
    ? isPreventativeMaintenance ? MYACCOUNT_VIVR_PM : MYACCOUNT_VIVR_SR
    : isPreventativeMaintenance ? MYACCOUNT_LOGGEDIN_PM : MYACCOUNT_LOGGEDIN_SR;

    this.gaService.buttonClickEvent(SR_PM_INIT_FLOW_HEADER, LOGO_HEADER);

    if (this.isIOS()){
      this.showDialog = true;
    }else{
      window.location.href = '/';
    }
  }

   navigateToDashboard(): void {
    window.location.href = '/'; // Redirect to the dashboard or home page
  }

  ngOnDestroy(): void {
    this.cleaner$.next();
    this.cleaner$.complete();
  }

  isIOS(): boolean {
    const ua = navigator.userAgent || navigator.vendor;

    // Check for iOS using user agent string
    return /iPad|iPhone|iPod/.test(ua) && !(navigator as any).msStream;
  }
  private computeShowFfsBanner(url: string): boolean {
      const base = url.split('?')[0].replace(/\/+$/, '');
      return this.dataService.isPlanFFS() && base === '/' + APP_ROUTES.SERVICE_REQUEST;
    }
}
